import SectionReveal from "@/components/SectionReveal";
import { Cpu, Database, Laptop, Network, Shield, Sparkles } from "lucide-react";
import { Link } from "react-router-dom";

const layers = [
  { label: "People + devices", detail: "Endpoint and Halo", icon: Laptop, href: "/halo" },
  { label: "Protected access", detail: "QuantumCloak", icon: Shield, href: "/quantumcloak" },
  { label: "Distributed fabric", detail: "LightningFlow Core + nodes", icon: Network, href: "/platform" },
  { label: "Operational state", detail: "QuantumCubeDB", icon: Database, href: "/quantumcubedb" },
  { label: "Governed intelligence", detail: "Sheila AI", icon: Sparkles, href: "/sheila-ai" },
];

export default function PlatformArchitecture({ compact = false }) {
  return (
    <SectionReveal as="figure" className={`lf-architecture lf-signal-diagram ${compact ? "lf-architecture-compact" : ""}`}>
      <figcaption className="lf-architecture-caption">
        <span>Integrated platform architecture</span>
        <span>Traffic → state → intelligence → governed action</span>
      </figcaption>
      <ol className="lf-architecture-flow">
        {layers.map(({ label, detail, icon: Icon, href }, index) => (
          <li key={label}>
            <Link to={href} className="lf-architecture-node">
              <span className="lf-node-number">0{index + 1}</span>
              <Icon className="h-5 w-5" strokeWidth={1.6} aria-hidden="true" />
              <span>
                <strong>{label}</strong>
                <small>{detail}</small>
              </span>
            </Link>
          </li>
        ))}
      </ol>
      <div className="lf-architecture-core">
        <Cpu className="h-5 w-5" strokeWidth={1.6} aria-hidden="true" />
        <span>One policy and orchestration plane</span>
        <i aria-hidden="true" />
        <span>Cloud · edge · branch · sovereign · endpoint</span>
      </div>
    </SectionReveal>
  );
}
